export enum SocketEvents {
  // Socket EMIT Events
  GetNotification = 'getNotification',
  SendNotification = 'sendNotification',

  // Socket Chat Events
  JoinChatRoom = 'join',
  ChatRoomData = 'roomData',
  ChatMessageSent = 'msgsent',
  ChatFirstUserMessage = 'firstusermsg',

  ForceLogout = 'forceLogout',
}
